// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__2K6xg","footer":"Form_footer__3vwln"};